import apiEndpoint from '../utils/apiEndpoint'
import { event, set } from 'vue-gtag'
import type { AxiosResponse } from 'axios'

const API_URL = import.meta.env.VITE_API_URL;

class AuthService {
  login(credentials: LoginRequest): Promise<LoginResponse> {
    return apiEndpoint({
      url: `${API_URL}/login`,
      method: 'post',
      payload: credentials,
      responseHandler: (response: AxiosResponse): LoginResponse => {
        if (response.data.user.access_token) {
          const user = response.data.user
          localStorage.setItem('user', JSON.stringify(user))
          // https://developers.google.com/analytics/devguides/collection/ga4/user-id?client_type=gtag
          set({
            user_id: user.ID,
            user_properties: {
              organization_id: user.organizationID,
              role: user.role,
            }
          })
          event('login')
          // calculate and store the token's expiration timestamp, so that
          // auth-interceptor.js can detect when it has expired
          const now = Math.floor(new Date().getTime() / 1000) // get the current Unix timestamp in seconds
          const user_expiration_dt = now + user.expires_in
          localStorage.setItem('user_expiration_dt', user_expiration_dt)
        }
        return response.data
      }
    })
  }
  logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('path')
    localStorage.removeItem('user_expiration_dt')
    set({
      user_id: null,
      user_properties: {organization_id: null, role: null}
    })
  }

  confirmAccount(payload: ConfirmAccountRequest) {
    return apiEndpoint({
      url: API_URL + '/users/confirm_account',
      method: 'post',
      payload: payload,
    })
  }

  forgotPassword(payload: ForgotPasswordRequest) {
    return apiEndpoint({
      url: API_URL + '/users/forgot_password',
      method: 'post',
      payload: payload,
    })
  }

  confirmForgotPassword(payload: ConfirmForgotPasswordRequest) {
    return apiEndpoint({
      url: API_URL + '/users/confirm_forgot_password',
      method: 'post',
      payload: payload,
    })
  }

}

export default new AuthService()

export type LoginRequest = {
  username: string
  password: string
}

export type LoginResponse = {
  user: {
    ID: number
    organizationID: number
    username: string
    firstName: string
    lastName: string
    email: string
    phone: string
    live: boolean
    receiveSummaryEmails: boolean
    role: string // TODO: create an enum
    access_token: string
    expires_in: number
  }
  userSolutions: {
    locationID: number
    universalInventoryRead: boolean
    universalInventoryWrite: boolean
    rateManagementRead: boolean
    rateManagementWrite: boolean
    blackoutsRead: boolean
    blackoutsWrite: boolean
    reportingRead: boolean
    reportingWrite: boolean
    rateParityRead: boolean
    rateParityWrite: boolean
    maxCapacityRead: boolean
    maxCapacityWrite: boolean
    uriRead: boolean
    uriWrite: boolean
  }[]
}

export type ConfirmAccountRequest = {
  username: string
  tempPassword: string
  newPassword: string
}

export type ForgotPasswordRequest = {
  username: string
}

export type ConfirmForgotPasswordRequest = {
  username: string
  verificationCode: string
  newPassword: string
}
